import { createContext, useCallback, useContext } from 'react';
import { string as stringUtil } from '@eti/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const TranslationContext = /*#__PURE__*/createContext({
  translations: {},
  options: {}
});
const TranslationProvider = _ref => {
  let {
    translations = {},
    options = {
      alwaysUseKeys: false,
      useKeyWhenTranslationNotFound: false,
      warnWhenTranslationNotFound: false,
      clearCache: false
    },
    children
  } = _ref;
  return /*#__PURE__*/_jsx(TranslationContext.Provider, {
    value: {
      translations,
      options
    },
    children: children
  });
};
export const getTranslation = (key, translations, options) => {
  const {
    alwaysUseKeys,
    useKeyWhenTranslationNotFound,
    warnWhenTranslationNotFound
  } = options;
  if (alwaysUseKeys) {
    return key;
  }
  const translation = key && translations[key];
  if (translation) {
    return translation;
  }
  if (warnWhenTranslationNotFound) {
    console.warn(`[TranslationContext] Key "${key}" has no translation.`); // eslint-disable-line no-console
  }
  if (useKeyWhenTranslationNotFound) {
    return key;
  }
  return '';
};
const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  const {
    translations,
    options
  } = context;
  const t = useCallback(function (key) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    return params.length === 0 ? getTranslation(key, translations, options) : stringUtil.insertArgument(getTranslation(key, translations, options), ...params);
  }, [options, translations]);
  const nonDebugT = useCallback(function (key) {
    const translationKey = getTranslation(key, translations, {
      ...options,
      alwaysUseKeys: false
    });
    for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      params[_key2 - 1] = arguments[_key2];
    }
    return params.length === 0 ? translationKey : stringUtil.insertArgument(translationKey, ...params);
  }, [options, translations]);
  return {
    t,
    nonDebugT
  };
};
export { TranslationProvider, useTranslation };